<template lang="pug">
.modal.fade(ref='modal')
  .modal-dialog
    .modal-content
      .modal-header
          button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
          h4.modal-title {{$t("modals.selectAGroup.title")}} 
      .modal-body
        .alert.alert-info.text-muted(v-if="options.helpText") {{$t(options.helpText)}}
        select-a-group-div(@select-group="selectGroup", :filter-groups="filterGroups")  
</template>

<script>
import SelectAGroupDiv from '@/components/shared/SelectAGroupDiv'
import modalsBus from '@/components/shared/ModalsBus'
import $ from 'jquery'

export default {
  name: 'GroupSelection',
  components: {
    SelectAGroupDiv
  },
  data: () => {
    return {
      options: {}
    }
  },
  mounted () {
    modalsBus.onOpen((arg, options) => {
      if (arg === modalsBus.modals.SELECT_A_GROUP) {
        this.options = options
        if (!this.options.onSelectGroup) {
          console.error('options.onSelectGroup must be defined')
        }
        $(this.$refs.modal).modal('show')
      } else {
        this.closeModal()
      }
    })
    modalsBus.onCloseAll(() => {
      this.closeModal()
    })
  },
  computed: {
    filterGroups () {
      console.log(this.options)
      return this.options.filterGroups || ((group) => true)
    }
  },
  methods: {
    selectGroup (group) {
      this.options.onSelectGroup(group)
    },
    closeModal () {
      $(this.$refs.modal).modal('hide')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SelectAGroupModal.vue?1f8d73be